import React from "react"
import ThinButton from "@components/common/thin-button/ThinButton"
import ThinButtonBordered from "@components/common/thin-button-bordered/ThinButtonBordered"
import { animateScroll } from "react-scroll"

import * as s from "./GermanyHero.module.scss"

export const GermanyHero = ({ data }) => {
  const imageSrc = data?.topImage?.localFile?.publicURL
  const imageSrcMobile = data?.topImageMobile?.localFile?.publicURL

  return (
    <div className={s.germanyHeroWrapper}>
      {imageSrc && (
        <div
          className={`
    ${s.germanyHeroWrapper__inner}
    ${s.germanyHeroWrapper__desktop}
    `}
        >
          <div
            aria-label={
              data?.topImage?.altText ? data?.topImage?.altText : data.title
            }
            role="image"
            className={`${s.topImage}`}
            style={
              data
                ? {
                    backgroundImage: `url(${imageSrc})`,
                  }
                : {}
            }
          >
            <div className={s.topImage__content}>
              <div className={s.topImage__links}>
                {data.gLinks &&
                  data.gLinks[0].link &&
                  data.gLinks.map((item, i) => {
                    return (
                      <ThinButton
                        key={i}
                        to={item.link.url}
                        target={item.link.target}
                        className={s.topImage__link}
                        external={item.link.target === "_blank"}
                        backgroundColor="#dd3f40"
                        textColor="#fff"
                      >
                        {item.link.title}
                      </ThinButton>
                    )
                  })}

                {/* <ThinButtonBordered
                  onClick={() => {
                    animateScroll.scrollMore(window.innerHeight * 0.95)
                  }}
                  className={s.topImage__link}
                  backgroundColor="#dd3f40"
                  textColor="#0c1a31"
                >
                  Learn more
                </ThinButtonBordered> */}
              </div>
            </div>
          </div>
        </div>
      )}

      {imageSrcMobile && (
        <div
          className={`
    ${s.germanyHeroWrapper__inner}
    ${s.germanyHeroWrapper__mobile}
    `}
        >
          <div
            aria-label={
              data?.topImage?.altText ? data?.topImage?.altText : data.title
            }
            role="image"
            className={`${s.topImage}`}
            style={
              data
                ? {
                    backgroundImage: `url(${imageSrcMobile})`,
                  }
                : {}
            }
          >
            <div className={s.topImage__content}>
              <div className={s.topImage__links}>
                {data.gLinks &&
                  data.gLinks[0].link &&
                  data.gLinks.map((item, i) => {
                    return (
                      <ThinButton
                        key={i}
                        to={item.link.url}
                        target={item.link.target}
                        className={s.topImage__link}
                        external={item.link.target === "_blank"}
                        backgroundColor="#dd3f40"
                        textColor="#fff"
                      >
                        {item.link.title}
                      </ThinButton>
                    )
                  })}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
